import '../../../bundles/translations/ru';
import {getCurrentLocale} from '../../store/regional-settings-store';

import ckEditor from '../../../bundles/ckeditor';

function initMarkdownEditorComponent(app) {
    app.component('markdown-editor',
        {
            template: '<div></div>',
            props: {
                modelValue: {required: true},
                language: {required: false},
                placeholder: {required: false},
            },
            data() {
                return {
                    classicEditor: ckEditor,
                    editor: null,
                    turndownService: null,
                    currentLanguage: this.language || getCurrentLocale(),
                };
            },
            emits: ['update:modelValue'],
            methods: {
                _initEditor(ClassicEditor) {
                    if (ClassicEditor != null && this.$el != null) {
                        ClassicEditor.defaultConfig.language = this.currentLanguage;
                        ClassicEditor.create(this.$el, {placeholder: this.placeholder})
                            .then((editor) => {
                                this._initEditorData(editor);
                            })
                            .catch((err) => {
                                console.error(err.stack);
                            });
                    }
                },
                _initEditorData(editor) {
                    editor.data.set(this.modelValue || '');
                    editor.model.document.on('change:data',
                        () => {
                            this.$emit('update:modelValue', editor.getData());
                        });
                },
            },
            mounted() {
                this._initEditor(this.classicEditor);
            },
        });
}

export default initMarkdownEditorComponent;
